<template>
  <curl-response v-bind:curl="curl" request="Purchases"></curl-response>
</template>

<script>
import curl from 'services/curl'
import CurlResponse from 'components/CurlResponse'

export default {
  name: 'curl-purchases',
  data () {
    return {
      curl: null
    }
  },
  created () {
    var session = this.$route.query.session
    curl.purchases(this, session)
  },
  components: {
    CurlResponse
  }
}
</script>



// WEBPACK FOOTER //
// src/views/curl/CurlPurchases.vue